import { render, staticRenderFns } from "./SidebarLinks.vue?vue&type=template&id=250d7a36"
import script from "./SidebarLinks.vue?vue&type=script&lang=js"
export * from "./SidebarLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports